/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
const i=Symbol("isMapNotesGraphicOriginSymbol");function n(n){return!!n&&i in n}export{n as isMapNotesGraphicOrigin,i as isMapNotesGraphicOriginSymbol};
